import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { SnapshotSpectralMask } from 'types';

export const clearMasks = ({ snapshotId }: { snapshotId: number }) => {
  return axios.delete(`/api/snapshots/${snapshotId}/spectral-masks/clear`);
};

type UseClearMasksOptions = {
  snapshotId: number;
  config?: MutationConfig<typeof clearMasks>;
};

export const useClearMasks = ({ config, snapshotId }: UseClearMasksOptions) => {
  return useMutation({
    onMutate: async () => {
      await queryClient.cancelQueries(['snapshot', snapshotId, 'masks']);

      const previousMasks = queryClient.getQueryData<SnapshotSpectralMask[]>([
        'snapshot',
        snapshotId,
        'masks',
      ]);

      queryClient.setQueryData(['snapshot', snapshotId, 'masks'], []);

      return { previousMasks };
    },
    onError: (_, __, context: any) => {
      if (context?.previousMasks) {
        queryClient.setQueryData(
          ['snapshot', snapshotId, 'masks'],
          context.previousMasks
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['snapshot', snapshotId]);
    },
    ...config,
    mutationFn: clearMasks,
  });
};
